module.exports = __webpack_public_path__ + "img/ADpic@3x.dc0bd1cf.png";